/* VANA Geschenkverpackung im Warenkorb – ausgelagert 12.10.2026 aus snippets/vana-giftwrap.liquid. Konfiguration kommt aus window.VANA_GW_CFG (im Snippet gesetzt). */
(function () {
  if (window.__VANA_GIFTWRAP__) return;
  window.__VANA_GIFTWRAP__ = true;

  var VARIANT_ID = (window.VANA_GW_CFG || {}).variantId;
  var PRICE = (window.VANA_GW_CFG || {}).price || '5 €';
  var TITLE = 'Als Geschenk verpacken';
  var TOOLTIP = 'Wir verpacken - du überreichst';
  var MORE_TEXT =
    'Dein Geschenk auf Seidenpapier gebettet und liebevoll verpackt. Bereit zum Übergeben und für strahlende Augen.';
  var THUMB = (window.VANA_GW_CFG || {}).thumb || '';
  var THUMB_FALLBACK =
    '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true">' +
    '<path d="M8.5 12.5h15l-1.1 12.1a1.6 1.6 0 0 1-1.6 1.4h-9.6a1.6 1.6 0 0 1-1.6-1.4z" stroke="#8a5a44" stroke-width="1.3" stroke-linejoin="round" fill="#fff"/>' +
    '<path d="M12.6 12.5v-1.8a3.4 3.4 0 0 1 6.8 0v1.8" stroke="#8a5a44" stroke-width="1.3" stroke-linecap="round"/>' +
    '<path d="M16 22.6s-2.7-1.6-2.7-3.3a1.45 1.45 0 0 1 2.7-.75 1.45 1.45 0 0 1 2.7.75c0 1.7-2.7 3.3-2.7 3.3z" fill="#e8c9b8"/>' +
    '</svg>';

  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

  var busy = false;
  var lastKnownState = null;

  /* ==================================================
       1) MESS-KENNZEICHEN FÜR DEN DRAWER-UPSELL
    ================================================== */

  var upsellIntentUntil = 0;

  function markUpsellIntent(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('#drawer-cart [data-upsell-add]')) {
      upsellIntentUntil = Date.now() + 4000;
      return;
    }

    // Bestätigung im Vorbestell-Popup, das durch einen Upsell-Klick geöffnet wurde
    if (target.closest('[data-vana-preorder-modal-confirm]') && upsellIntentUntil > Date.now() - 120000) {
      upsellIntentUntil = Date.now() + 4000;
    }
  }

  ['pointerup', 'touchend', 'click'].forEach(function (type) {
    window.addEventListener(type, markUpsellIntent, true);
  });

  if (window.fetch && !window.__VANA_UPSELL_FETCH_TAG__) {
    window.__VANA_UPSELL_FETCH_TAG__ = true;
    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';

        if (
          Date.now() < upsellIntentUntil &&
          /\/cart\/add(\.js)?(\?|$)/.test(url) &&
          init &&
          typeof init.body === 'string'
        ) {
          var body = JSON.parse(init.body);
          var tagItem = function (item) {
            if (!item || Number(item.id) === VARIANT_ID) return;
            item.properties = Object.assign({}, item.properties || {}, {
              _vana_source: 'cart_upsell',
            });
          };

          if (Array.isArray(body.items)) {
            body.items.forEach(tagItem);
          } else {
            tagItem(body);
          }

          init = Object.assign({}, init, { body: JSON.stringify(body) });
          upsellIntentUntil = 0;
        }
      } catch (error) {
        // Im Zweifel unverändert weiterschicken
      }

      return originalFetch.call(this, input, init);
    };
  }

  /* ==================================================
       2) GESCHENKVERPACKUNG
    ================================================== */

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('cart.js ' + response.status);
      return response.json();
    });
  }

  function postJson(path, payload) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    }).then(function (response) {
      if (!response.ok) throw new Error(path + ' ' + response.status);
      return response.json();
    });
  }

  function findGiftwrapLine(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i += 1) {
      if (Number(cart.items[i].variant_id) === VARIANT_ID) return cart.items[i];
    }
    return null;
  }

  function countOtherItems(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.filter(function (item) {
      return Number(item.variant_id) !== VARIANT_ID;
    }).length;
  }

  function applyStateToBox(box, isChecked) {
    var input = box.querySelector('[data-vana-giftwrap-toggle]');
    if (input) {
      input.checked = isChecked;
      input.disabled = false;
    }
    box.classList.toggle('is-checked', isChecked);
    box.classList.remove('is-busy');
  }

  function buildBox(id) {
    var box = document.createElement('label');
    box.className = 'vana-giftwrap';
    box.id = id;
    box.title = TOOLTIP;
    box.innerHTML =
      '<input type="checkbox" class="vana-giftwrap__input" data-vana-giftwrap-toggle>' +
      '<span class="vana-giftwrap__box" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>' +
      '</span>' +
      '<span class="vana-giftwrap__thumb">' +
      (THUMB || THUMB_FALLBACK) +
      '</span>' +
      '<span class="vana-giftwrap__content">' +
      '<span class="vana-giftwrap__head">' +
      '<span class="vana-giftwrap__title"><span class="vana-giftwrap__title-text"></span> <span class="vana-giftwrap__emoji" aria-hidden="true">🎁</span></span>' +
      '<span class="vana-giftwrap__price"></span>' +
      '</span>' +
      '</span>' +
      '<span class="vana-giftwrap__more" data-vana-gw-more role="button" tabindex="0" aria-expanded="false" aria-label="Mehr zur Geschenkverpackung">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>' +
      '</span>';

    box.querySelector('.vana-giftwrap__title-text').textContent = TITLE;
    box.querySelector('.vana-giftwrap__price').textContent = '+ ' + PRICE;

    if (lastKnownState !== null) applyStateToBox(box, lastKnownState);

    watchVisibility(box);

    // Aufklappbarer Hinweis unter der Zeile
    var wrap = document.createElement('div');
    wrap.className = 'vana-giftwrap-wrap';
    var panel = document.createElement('div');
    panel.className = 'vana-giftwrap__panel';
    panel.hidden = true;
    panel.textContent = MORE_TEXT;
    wrap.appendChild(box);
    wrap.appendChild(panel);

    var more = box.querySelector('[data-vana-gw-more]');
    function toggleMore(event) {
      event.preventDefault();
      event.stopPropagation();
      var open = panel.hidden;
      panel.hidden = !open;
      wrap.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    more.addEventListener('click', toggleMore);
    more.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') toggleMore(event);
    });

    return wrap;
  }

  /* Kurzer Anstupser, sobald die Zeile sichtbar wird (einmal pro Seitenaufruf, nur wenn nicht angehakt) */
  var nudged = false;

  function nudge(box) {
    if (nudged || lastKnownState === true) return;
    nudged = true;
    box.classList.remove('is-nudge');
    void box.offsetWidth;
    box.classList.add('is-nudge');
    window.setTimeout(function () {
      box.classList.remove('is-nudge');
    }, 2100);
  }

  function watchVisibility(box) {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.9) {
            window.setTimeout(function () {
              var rect = box.getBoundingClientRect();
              var stillVisible =
                rect.width > 0 &&
                rect.left >= 0 &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) + 1;
              if (stillVisible) nudge(box);
            }, 500);
          }
        });
      },
      { threshold: [0.9] },
    );
    observer.observe(box);
  }

  function mount() {
    var drawerSummary = document.querySelector('#drawer-cart [data-cart-bottom] .vana-cart-summary');

    if (drawerSummary && !document.getElementById('vana-giftwrap-drawer')) {
      drawerSummary.insertAdjacentElement('beforebegin', buildBox('vana-giftwrap-drawer'));
    }

    var checkoutBtn = document.querySelector('#drawer-cart .vana-cart-checkout-btn');
    if (checkoutBtn && !checkoutBtn.querySelector('.vana-lock')) {
      checkoutBtn.insertAdjacentHTML(
        'afterbegin',
        '<svg class="vana-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M8 11V8a4 4 0 0 1 8 0v3"></path></svg>',
      );
    }

    var payTarget = document.querySelector('#drawer-cart .vana-cart-payments');
    var payTpl = document.getElementById('vana-pay-icons-tpl');
    if (payTarget && payTpl && !payTarget.hasAttribute('data-vana-pay')) {
      payTarget.setAttribute('data-vana-pay', 'true');
      payTarget.innerHTML = '';
      payTarget.appendChild(payTpl.content.cloneNode(true));
    }

    var pageTotal = document.querySelector('.cart__template .cart__footer__total');

    if (pageTotal && !document.getElementById('vana-giftwrap-page')) {
      pageTotal.insertAdjacentElement('afterbegin', buildBox('vana-giftwrap-page'));
    }
  }

  function setUiState(isChecked) {
    lastKnownState = isChecked;
    document.querySelectorAll('.vana-giftwrap').forEach(function (box) {
      applyStateToBox(box, isChecked);
    });
  }

  function setUiBusy() {
    document.querySelectorAll('.vana-giftwrap').forEach(function (box) {
      var input = box.querySelector('[data-vana-giftwrap-toggle]');
      if (input) input.disabled = true;
      box.classList.add('is-busy');
    });
  }

  function showError(message) {
    var errorBox = document.querySelector('#drawer-cart [data-form-errors]');
    if (!errorBox) return;
    errorBox.textContent = message;
    errorBox.style.display = 'block';
    window.setTimeout(function () {
      errorBox.style.display = 'none';
      errorBox.textContent = '';
    }, 3500);
  }

  function announceCartChange() {
    return getCart().then(function (cart) {
      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true,
        }),
      );
      return cart;
    });
  }

  function isCartPage() {
    return !!document.getElementById('vana-giftwrap-page');
  }

  function setGiftwrap(shouldBeOn) {
    if (busy) return Promise.resolve();
    busy = true;
    setUiBusy();

    return getCart()
      .then(function (cart) {
        var line = findGiftwrapLine(cart);

        if (shouldBeOn) {
          if (line) return null;
          return postJson('cart/add.js', {
            items: [{ id: VARIANT_ID, quantity: 1 }],
          });
        }

        if (!line) return null;
        return postJson('cart/change.js', { id: line.key, quantity: 0 });
      })
      .then(function () {
        if (isCartPage()) {
          window.location.reload();
          return;
        }
        setUiState(shouldBeOn);
        return announceCartChange();
      })
      .catch(function (error) {
        console.error('VANA Geschenkverpackung', error);
        showError('Die Geschenkverpackung konnte gerade nicht geändert werden.');
        return sync(true);
      })
      .finally(function () {
        busy = false;
      });
  }

  function sync(force) {
    if (busy && !force) return Promise.resolve();

    return getCart()
      .then(function (cart) {
        var line = findGiftwrapLine(cart);

        // Nur noch die Verpackung im Warenkorb? Dann wieder entfernen.
        if (line && countOtherItems(cart) === 0) {
          return setGiftwrap(false);
        }

        // Pro Bestellung immer genau 1x Geschenkverpackung.
        if (line && line.quantity > 1) {
          busy = true;
          return postJson('cart/change.js', { id: line.key, quantity: 1 })
            .then(function () {
              busy = false;
              setUiState(true);
              if (isCartPage()) {
                window.location.reload();
                return;
              }
              return announceCartChange();
            })
            .catch(function () {
              busy = false;
            });
        }

        setUiState(!!line);
      })
      .catch(function (error) {
        console.error('VANA Geschenkverpackung sync', error);
      });
  }

  var syncTimer = null;

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      mount();
      sync();
    }, 150);
  }

  function observeLineItems() {
    document
      .querySelectorAll('#drawer-cart [data-line-items], .cart__template [data-line-items]')
      .forEach(function (element) {
        if (element.__vanaGiftwrapObserved) return;
        element.__vanaGiftwrapObserved = true;
        new MutationObserver(scheduleSync).observe(element, { childList: true });
      });
  }

  document.addEventListener('change', function (event) {
    var input = event.target && event.target.closest ? event.target.closest('[data-vana-giftwrap-toggle]') : null;
    if (!input) return;
    setGiftwrap(input.checked);
  });

  function init() {
    mount();
    observeLineItems();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
